var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mainAuxPage zj-flex-column" },
    [
      _c(
        "div",
        {
          staticClass: "zj-flex-row",
          staticStyle: {
            border: "1.5px solid rgb(221 221 221)",
            flex: "1",
            "background-color": "white",
            "margin-bottom": "10px",
            "box-shadow": "0 0 3px rgba(188, 186, 186, 0.8)",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "zj-flex-row",
              staticStyle: { margin: "0 5px", flex: "1" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "zj-flex-row hvr-grow-shadow",
                  staticStyle: {
                    "background-color": "#e35e00",
                    margin: "8px 12px",
                    "border-radius": "3%",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.gotolectureHall()
                    },
                  },
                },
                [
                  _c("div", { staticClass: "text-inner" }, [
                    _c("span", {
                      staticStyle: { display: "flex", flex: "0.3" },
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          color: "#FFFFFF",
                          "font-size": "37px",
                          display: "flex",
                          flex: "1",
                          "font-weight": "bold",
                        },
                      },
                      [_vm._v(_vm._s(_vm.LectureNum))]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          color: "#FFFFFF",
                          "font-size": "20px",
                          display: "flex",
                          flex: "1",
                        },
                      },
                      [_vm._v("可报名大赛数")]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._m(0),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "zj-flex-row hvr-grow-shadow",
                  staticStyle: {
                    "background-color": "#1f96b2",
                    margin: "8px 12px",
                    "border-radius": "3%",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.gotoLecture(1)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "text-inner" }, [
                    _c("span", {
                      staticStyle: { display: "flex", flex: "0.3" },
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          color: "#FFFFFF",
                          "font-size": "37px",
                          display: "flex",
                          flex: "1",
                          "font-weight": "bold",
                        },
                      },
                      [_vm._v(_vm._s(_vm.LectureAllowNum))]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          color: "#FFFFFF",
                          "font-size": "20px",
                          display: "flex",
                          flex: "1",
                        },
                      },
                      [_vm._v("已报名大赛数")]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._m(1),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "zj-flex-row hvr-grow-shadow",
                  staticStyle: {
                    "background-color": "#5675bf",
                    margin: "8px 12px",
                    "border-radius": "3%",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.gotocourseList()
                    },
                  },
                },
                [
                  _c("div", { staticClass: "text-inner" }, [
                    _c("span", {
                      staticStyle: { display: "flex", flex: "0.3" },
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          color: "#FFFFFF",
                          "font-size": "37px",
                          display: "flex",
                          flex: "1",
                          "font-weight": "bold",
                        },
                      },
                      [_vm._v(_vm._s(_vm.courseNum))]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          color: "#FFFFFF",
                          "font-size": "20px",
                          display: "flex",
                          flex: "1",
                        },
                      },
                      [_vm._v("可报名课程数")]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._m(2),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "zj-flex-row hvr-grow-shadow",
                  staticStyle: {
                    "background-color": "#029bdd",
                    margin: "8px 12px",
                    "border-radius": "3%",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.gotoCourse()
                    },
                  },
                },
                [
                  _c("div", { staticClass: "text-inner" }, [
                    _c("span", {
                      staticStyle: { display: "flex", flex: "0.3" },
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          color: "#FFFFFF",
                          "font-size": "37px",
                          display: "flex",
                          flex: "1",
                          "font-weight": "bold",
                        },
                      },
                      [_vm._v(_vm._s(_vm.courseAllowNum))]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          color: "#FFFFFF",
                          "font-size": "20px",
                          display: "flex",
                          flex: "1",
                        },
                      },
                      [_vm._v("已报名课程数")]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._m(3),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "zj-flex-row hvr-grow-shadow",
                  staticStyle: {
                    "background-color": "#894db8",
                    margin: "8px 12px",
                    "border-radius": "3%",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.gotoSignList()
                    },
                  },
                },
                [
                  _c("div", { staticClass: "text-inner" }, [
                    _c("span", {
                      staticStyle: { display: "flex", flex: "0.3" },
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          color: "#FFFFFF",
                          "font-size": "37px",
                          display: "flex",
                          flex: "1",
                          "font-weight": "bold",
                        },
                      },
                      [_vm._v(_vm._s(_vm.signNum))]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          color: "#FFFFFF",
                          "font-size": "20px",
                          display: "flex",
                          flex: "1",
                        },
                      },
                      [_vm._v("待签到数")]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._m(4),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "zj-flex-row hvr-grow-shadow",
                  staticStyle: {
                    "background-color": "#31a28e",
                    margin: "8px 12px",
                    "border-radius": "3%",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.gotoSignList()
                    },
                  },
                },
                [
                  _c("div", { staticClass: "text-inner" }, [
                    _c("span", {
                      staticStyle: { display: "flex", flex: "0.3" },
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          color: "#FFFFFF",
                          "font-size": "37px",
                          display: "flex",
                          flex: "1",
                          "font-weight": "bold",
                        },
                      },
                      [_vm._v(_vm._s(_vm.homeworkNum))]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          color: "#FFFFFF",
                          "font-size": "20px",
                          display: "flex",
                          flex: "1",
                        },
                      },
                      [_vm._v("待提交作业数")]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._m(5),
                ]
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "zj-flex-row",
          staticStyle: { flex: "3", "margin-top": "7px" },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                border: "1.5px solid rgb(221 221 221)",
                display: "flex",
                flex: "1",
                "margin-right": "7px",
                "box-shadow": "0 0 3px rgba(188, 186, 186, 0.8)",
              },
            },
            [
              _c("div", { staticClass: "zj-flex-column" }, [
                _c(
                  "div",
                  {
                    staticClass: "zj-tbar",
                    staticStyle: {
                      "margin-bottom": "0",
                      "background-color": "#e5e5e5",
                      "border-bottom": "3px solid rgb(221 221 221)",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "zj-flex-row",
                        staticStyle: {
                          "justify-content": "space-between",
                          "align-items": "center",
                        },
                      },
                      [
                        _vm._m(6),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "flex-direction": "row",
                              "margin-right": "10px",
                            },
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                icon: "el-icon-more",
                                title: "更多",
                                size: "mini",
                                circle: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.gotoLecture(1)
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("el-button", {
                              attrs: {
                                icon: "el-icon-refresh",
                                title: "刷新",
                                size: "mini",
                                circle: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.refreshLectureData()
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      padding: "5px 30px",
                      display: "flex",
                      flex: "1",
                      "background-color": "white",
                    },
                  },
                  [
                    _c(
                      "zj-table",
                      {
                        ref: "lectureTable",
                        attrs: {
                          data: _vm.lectureData,
                          "show-header": false,
                          border: false,
                          "highlight-current-row": false,
                          "row-style": { height: "40px", color: "#8d9196" },
                        },
                        on: { "row-dblclick": _vm.openLectureDetail },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "p_no",
                            label: "比赛编码",
                            align: "center",
                            "show-overflow-tooltip": "",
                            width: "180px",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "p_name",
                            label: "比赛名称",
                            align: "center",
                            "show-overflow-tooltip": "",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "",
                            label: "",
                            align: "center",
                            "show-overflow-tooltip": "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm._f("dateFilter")(
                                          scope.row.competition_startdate,
                                          "yyyy-MM-dd HH:mm"
                                        )
                                      ) +
                                      " ~ " +
                                      _vm._s(
                                        _vm._f("dateFilter")(
                                          scope.row.competition_enddate,
                                          "yyyy-MM-dd HH:mm"
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { width: "40", "align-items": "center" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("div", { staticClass: "zj-flex-center" }, [
                                    _c("i", {
                                      staticClass: "el-icon-info",
                                      staticStyle: {
                                        color: "#409EFF",
                                        "font-size": "16px",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openLectureDetail(
                                            scope.row
                                          )
                                        },
                                      },
                                    }),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", { attrs: { width: "-1" } }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                border: "1.5px solid rgb(221 221 221)",
                display: "flex",
                flex: "1",
                "margin-left": "7px",
                "box-shadow": "0 0 3px rgba(188, 186, 186, 0.8)",
              },
            },
            [
              _c("div", { staticClass: "zj-flex-column" }, [
                _c(
                  "div",
                  {
                    staticClass: "zj-tbar",
                    staticStyle: {
                      "margin-bottom": "0",
                      "background-color": "#e5e5e5",
                      "border-bottom": "3px solid rgb(221 221 221)",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "zj-flex-row",
                        staticStyle: {
                          "justify-content": "space-between",
                          "align-items": "center",
                        },
                      },
                      [
                        _vm._m(7),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "flex-direction": "row",
                              "margin-right": "10px",
                            },
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                icon: "el-icon-more",
                                title: "更多",
                                size: "mini",
                                circle: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.gotoLecture(2)
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("el-button", {
                              attrs: {
                                icon: "el-icon-refresh",
                                title: "刷新",
                                size: "mini",
                                circle: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.refreshCourseData()
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      padding: "5px 30px",
                      display: "flex",
                      flex: "1",
                      "background-color": "white",
                    },
                  },
                  [
                    _c(
                      "zj-table",
                      {
                        ref: "courseTable",
                        staticClass: "custom-table",
                        attrs: {
                          data: _vm.courseData,
                          "show-header": false,
                          border: false,
                          "highlight-current-row": false,
                          "row-style": { height: "40px", color: "#8d9196" },
                        },
                        on: { "row-dblclick": _vm.openLectureDetail },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "p_no",
                            label: "活动编码",
                            align: "center",
                            "show-overflow-tooltip": "",
                            width: "180px",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "p_name",
                            label: "活动名称",
                            align: "center",
                            "show-overflow-tooltip": "",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "",
                            label: "",
                            align: "center",
                            "show-overflow-tooltip": "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm._f("dateFilter")(
                                          scope.row.competition_startdate,
                                          "yyyy-MM-dd HH:mm"
                                        )
                                      ) +
                                      " ~ " +
                                      _vm._s(
                                        _vm._f("dateFilter")(
                                          scope.row.competition_enddate,
                                          "yyyy-MM-dd HH:mm"
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { width: "40", "align-items": "center" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("div", { staticClass: "zj-flex-center" }, [
                                    _c("i", {
                                      staticClass: "el-icon-info",
                                      staticStyle: {
                                        color: "#409EFF",
                                        "font-size": "16px",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openLectureDetail(
                                            scope.row
                                          )
                                        },
                                      },
                                    }),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", { attrs: { width: "-1" } }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            width: "750px",
            title: "详情",
            visible: _vm.showLectureDetail,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showLectureDetail = $event
            },
          },
        },
        [
          _c(
            "zj-form",
            {
              ref: "lectureForm",
              attrs: { model: _vm.lectureContent, "label-width": "150px" },
            },
            [
              _c(
                "div",
                { staticClass: "dialog-form" },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom-form-item",
                      staticStyle: { width: "650px" },
                      attrs: { label: "编码：", prop: "p_no" },
                    },
                    [_vm._v(_vm._s(_vm.lectureContent.p_no))]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom-form-item",
                      staticStyle: { width: "650px" },
                      attrs: { label: "名称:", prop: "p_name" },
                    },
                    [_vm._v(_vm._s(_vm.lectureContent.p_name))]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "dialog-form" },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom-form-item",
                      staticStyle: { width: "650px" },
                      attrs: {
                        label: "报名开始时间:",
                        prop: "competition_startdate",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm._f("dateFilter")(
                            _vm.lectureContent.competition_startdate,
                            "yyyy-MM-dd HH:mm"
                          )
                        )
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom-form-item",
                      staticStyle: { width: "650px" },
                      attrs: {
                        label: "报名结束时间:",
                        prop: "competition_enddate",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm._f("dateFilter")(
                            _vm.lectureContent.competition_enddate,
                            "yyyy-MM-dd HH:mm"
                          )
                        )
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "dialog-form" },
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "650px" },
                      attrs: { label: "介绍:", prop: "p_note" },
                    },
                    [
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              flex: "1",
                              "flex-direction": "row",
                              "flex-flow": "wrap",
                              "letter-spacing": "0.1em",
                              "line-height": "18px",
                              "align-items": "center",
                              "min-height": "40px",
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.lectureContent.p_note) +
                                "\n            "
                            ),
                          ]
                        ),
                      ],
                    ],
                    2
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            width: "750px",
            title: "课程详情",
            visible: _vm.showCourseDetail,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showCourseDetail = $event
            },
          },
        },
        [
          _c(
            "zj-form",
            {
              ref: "courseForm",
              attrs: { model: _vm.courseContent, "label-width": "150px" },
            },
            [
              _c(
                "div",
                { staticClass: "dialog-form" },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom-form-item",
                      staticStyle: { width: "650px" },
                      attrs: { label: "课程名称：", prop: "p_name" },
                    },
                    [_vm._v(_vm._s(_vm.courseContent.p_name))]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom-form-item",
                      staticStyle: { width: "650px" },
                      attrs: { label: "讲师：", prop: "emp_name" },
                    },
                    [_vm._v(_vm._s(_vm.courseContent.emp_name))]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "dialog-form" },
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "650px" },
                      attrs: { label: "课程说明：", prop: "p_note" },
                    },
                    [
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              flex: "1",
                              "flex-direction": "row",
                              "flex-flow": "wrap",
                              "letter-spacing": "0.1em",
                              "line-height": "18px",
                              "align-items": "center",
                              "min-height": "40px",
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.courseContent.p_note) +
                                "\n            "
                            ),
                          ]
                        ),
                      ],
                    ],
                    2
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "dialog-form" },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom-form-item",
                      staticStyle: { width: "650px" },
                      attrs: {
                        label: "报名开始时间：",
                        prop: "competition_startdate",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm._f("dateFilter")(
                            _vm.courseContent.competition_startdate,
                            "yyyy-MM-dd HH:mm"
                          )
                        )
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom-form-item",
                      staticStyle: { width: "650px" },
                      attrs: {
                        label: "报名结束时间：",
                        prop: "competition_enddate",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm._f("dateFilter")(
                            _vm.courseContent.competition_enddate,
                            "yyyy-MM-dd HH:mm"
                          )
                        )
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-inner" }, [
      _c("img", {
        staticStyle: { width: "50px", height: "50px", display: "flex" },
        attrs: { src: "/static/base/img/培训申请1.png" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-inner" }, [
      _c("img", {
        staticStyle: { width: "50px", height: "50px", display: "flex" },
        attrs: { src: "/static/base/img/24_学生.png" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-inner" }, [
      _c("img", {
        staticStyle: { width: "50px", height: "50px", display: "flex" },
        attrs: { src: "/static/base/img/online-communication2.png" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-inner" }, [
      _c("img", {
        staticStyle: { width: "50px", height: "50px", display: "flex" },
        attrs: { src: "/static/base/img/w_学生-64.png" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-inner" }, [
      _c("img", {
        staticStyle: { width: "50px", height: "50px", display: "flex" },
        attrs: { src: "/static/base/img/签到.png" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-inner" }, [
      _c("img", {
        staticStyle: { width: "50px", height: "50px", display: "flex" },
        attrs: { src: "/static/base/img/作业-选中.png" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticStyle: {
          display: "flex",
          "flex-direction": "row",
          margin: "5px 10px",
          "align-items": "center",
        },
      },
      [
        _c("div", { staticClass: "zj-flex-ceter" }, [
          _c("i", {
            staticClass: "el-icon-s-platform",
            staticStyle: {
              "font-size": "30px",
              "margin-right": "10px",
              color: "#409EFF",
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticStyle: { "font-weight": "600", color: "#409EFF" } }, [
          _vm._v("我的大赛"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticStyle: {
          display: "flex",
          "flex-direction": "row",
          margin: "5px 10px",
          "align-items": "center",
        },
      },
      [
        _c("div", { staticClass: "zj-flex-ceter" }, [
          _c("i", {
            staticClass: "el-icon-s-marketing",
            staticStyle: {
              "font-size": "30px",
              "margin-right": "10px",
              color: "#409EFF",
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticStyle: { "font-weight": "600", color: "#409EFF" } }, [
          _vm._v("我的活动"),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }